// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getSubKegiatan, insertSubKegiatan, subKegiatanSelector, updateSubKegiatan} from './subKegiatanSlice';

import {Colors} from "../../../assets/Colors";

const SubKegiatanPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const subKegiatan = useSelector(
        subKegiatanSelector
    );


    useEffect(() => {
        dispatch(getSubKegiatan({
            start: start,
            count: count,
            search: '',
        }));

    }, []);

    useEffect(() => {

        if ((search !== '') && subKegiatan.isGetSuccess && !subKegiatan.isGetFetching) {
            let calc = subKegiatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = subKegiatan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && subKegiatan.isGetSuccess && !subKegiatan.isGetFetching) {
            let calc = subKegiatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = subKegiatan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!subKegiatan?.isGetFetching && subKegiatan.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = subKegiatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = subKegiatan.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getSubKegiatan({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (subKegiatan.isGetSuccess) {
                alertService.success(subKegiatan.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getSubKegiatan({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (subKegiatan.isUpdateSuccess) {
                alertService.success(subKegiatan.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateSubKegiatan({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetSubKegiatan(params) {
    //   return dispatch(getSubKegiatan(params));
    // }

    function handleInsertSubKegiatan(param) {
        setInsertFetch(true);
        const params = {
            NamaSubKegiatan: param.inputOneValue,
            KelompokKegiatanID: param.dropdownKelompokKegiatanValue,
        };

        dispatch(insertSubKegiatan(params));
    }

    function handleUpdateSubKegiatan(param) {
        setUpdateFetch(true);

        const params = {
            KelompokKegiatanID: param.dropdownKelompokKegiatanValue,
            NamaSubKegiatan: param.inputOneValue,
            SubKegiatanID: currentData.SubKegiatanID,
            status: param.status,
        };
        dispatch(updateSubKegiatan(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getSubKegiatan(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getSubKegiatan(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (subKegiatan.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? subKegiatan.count : newCount,
            search: search,
        }
        dispatch(getSubKegiatan(params));

        setPage(1);
        setCount((newCount === "-1") ? subKegiatan.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                handleSearch={handleSearch}
                                searchPlaceholder="SubKegiatan"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master SubKegiatan"
                                tableData={subKegiatan.data}
                                colOneTitle="ID"
                                colOneData="SubKegiatanID"
                                colTwoTitle="Nama SubKegiatan"
                                colTwoData="NamaSubKegiatan"
                                status="Status"

                                fetching={subKegiatan.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Sub Kelompok Kegiatan"
                        dropdownKelompokKegiatan={true}
                        inputOneTitle="Nama Sub Kelompok Kegiatan"
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertSubKegiatan}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.SubKegiatanID}
                        modal={handleModal}
                        modalTitle="Ubah Sub Kelompok Kegiatan"
                        dropdownKelompokKegiatan={true}
                        dropdownKelompokKegiatanValue={currentData.KelompokKegiatanID}
                        inputOneTitle="Nama Sub Kelompok Kegiatan"
                        inputOneValue={currentData.NamaSubKegiatan}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateSubKegiatan}
                    />
                }
            </div>

        )
    }

}


export default SubKegiatanPage;